import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import PageLayout from '@/components/PageLayout';
import User from '@/store/user';
import { getLayoutProps } from '@/utils/layout/layout';
import Credentials from '@/components/Credentials/Credentials';
import { getOrFetchConfiguration } from '@/utils/getConfiguration';
import Cookies from 'universal-cookie';

export default function UserProfile({ responsiveLogo }) {
  const [user, setUser] = useState();
  const [config, setConfig] = useState();
  const router = useRouter();

  const cookies = new Cookies();
  const authorization = cookies.get('token');
  useEffect(() => {
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
    }

    getConfiguration();
  }, []);

  useEffect(() => {
    const user$ = User.subscribe(_user => {
      if (isEmpty(_user)) {
        router.replace('/');
        return;
      }
      setUser(_user);
    });
    return () => user$.unsubscribe();
  }, []);

  if (!user?._id) return null;

  return (
    <>
      <Head>
        <title>{process.env.displayName}</title>
        <meta name="description" content={`App for ${process.env.displayName} by Wave Grocery`} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={responsiveLogo} />
      </Head>
      {user && <Credentials user={user} config={config} />}
    </>
  );
}

UserProfile.getLayout = function getLayout(page) {
  return (
    <PageLayout isUserLayout userSelectedMenu={'credentials'}>
      {page}
    </PageLayout>
  );
};

export async function getStaticProps({ locale }) {
  const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: 0 } }, locale);

  const messages = {
    common: (await import(`../../../../prebuild-data/i18n/${locale}/common.json`)).default,
    user_credentials: (await import(`../../../../prebuild-data/i18n/${locale}/user_credentials.json`)).default,
    account_details: (await import(`../../../../prebuild-data/i18n/${locale}/account_details.json`)).default,
  };

  return {
    props: {
      ...layoutProps,
      messages,
    },
  };
}
